import styled from 'styled-components'

export const DemandStyle = styled.div`
  margin: 140px 0 140px 0;
  display: flex;
  padding: 0px 0;
  position: relative;
  > img {
    position: absolute;
    z-index: -1;
    width: 100%;
    display: block;
    left: 0;
    right: 0;
    bottom: 0;
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    margin: 50px 0;
  }
  .bottom-column {
    margin-bottom: 60px;
  }
  .text-body-wrap {
    margin-top: 20px;
    margin: 0 auto;
  }
  .border-text-wrap {
    display: flex;
    justify-content: center;
  }
  .bottom-margin {
    margin-bottom: 20px;
  }
`

export const ListCleanStyle = styled.div`
  .title-service {
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #888888;
    display: flex;
    text-align: center;
    width: 100%;
    margin-bottom: 20px;
  }
  .list {
    display: flex;
    margin: 10px 0;
    width: 100%;
    flex-direction: column;
    &-row {
      display: flex;
      margin: 8px 0;
      width: 100%;
      align-items: center;
      flex-direction: row;
      .check {
        display: flex;
        width: 30px;
        height: 30px;
        margin-right: 10px;
        img.check {
          display: block;
          padding: 0;
          width: 100%;
        }
      }
      span {
        font-size: 18px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #333333;
        text-align: left;
      }
    }
  }
`
